import { Fragment } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export const ProductListSkeleton = () => {
  return (
    <div className="col-lg-12 mt-4">
      {/* Product */}
      <div className="product-list row-product-list">
        <div className="product-load-img">
          <div className="product-image-load" />
        </div>
        <div className="product-load-content">
          <div className="product-title-load" />
          <div className="product-title-load" />
          <div className="product-btn-load" />
        </div>
      </div>
      {/* Product */}
    </div>
  );
};

export const PriceRowSkeleton = ({ count = 3 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div className="pricingDetails-content-list   pricingDetails-content-listGreen" key={index}>
          <div className="price-ex">
            <Skeleton height={16} width={70} />
          </div>
          <div className="price-ex">
            <Skeleton height={16} width={70} />
          </div>
          <div className="price-ex">
            <Skeleton height={16} width={70} />
          </div>
        </div>
      ))}
    </>
  );
};

export const PriceTableContainerSkeleton = ({ count }) => {
  return (
    <Fragment>
      {Array.from({ length: count ?? 3 }).map((_, index) => (
        <div className="pricingDetails-content-list d-lg-flex flex-lg-column" key={index}>
          <div className="price-ex order-lg-2">
            <Skeleton height={16} width={50} />
          </div>
          <div className="price-ex order-lg-3">
            <Skeleton height={16} width={50} />
          </div>
          <div className="price-ex order-lg-1">
            <Skeleton height={16} width={50} />
          </div>
        </div>
      ))}
    </Fragment>
  );
};
